import useSWRImmutable from "swr/immutable";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { PatrolSettings } from "./types/patrolSettings";

export const usePatrolSettings = (signal: AbortSignal, configurationId?: string) => {
  const api = useApi();
  const url = `/settings/patrol${configurationId ? `?configuration_id=${configurationId}` : ""}`;
  return useSWRImmutable<PatrolSettings, CustomError, string>(url, (url) => api.get<PatrolSettings>({ url, signal }));
};
